'use strict';
(function(angular) {
  angular.module('fetchtv.Directives')
    .directive('ftFooter', function() {
      return {
        restrict: 'AE',
        replace: true,
        templateUrl: 'views/common/footer.html',
        scope: true,
        controller: ['$scope', function($scope) {
          $scope.currentYear = (new Date()).getFullYear();
        }]
      };
    });
})(angular);

